import DivisionPage from "@/components/DivisionPage";
import { DIVISIONS } from "@/data/divisions";

export default function Logistica() {
  return <DivisionPage division={DIVISIONS.logistica} />;
}
